import React from "react";

export const Subheading = ({ text }) => (
  <p style={{ color: "#FFCA28" }}>{text}</p>
);
